// extracted by mini-css-extract-plugin
export default {"wrapper":"introduction2_wrapper__A5ezC","button":"introduction2_button__e97WT"};